import { MessagingChannel } from "@whatsper/texterchat-common";
export var ChatPaneName;
(function (ChatPaneName) {
    ChatPaneName["search"] = "search";
    ChatPaneName["media"] = "media";
})(ChatPaneName || (ChatPaneName = {}));
export const channelSupportsTM = (channelName) => {
    return [
        MessagingChannel.whatsapp,
    ].includes(channelName);
};
